import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Typography,
  CircularProgress,
  LinearProgress
} from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

const useStyles = makeStyles((theme) => ({
  checked: {
    paddingBottom: '20px',
    fill: 'green'
  },
  container: {
    height: '200px',
    width: '400px'
  },
  content: {
    textAlign: 'center',
    padding: '40px 10px 10px 10px'
  },
  redirecting: {
    marginBottom: '5px'
  }
}))

const ConfirmationAnimation = ({message, isComplete}) => {
  const classes = useStyles()
  const [displayVerified, setDisplayVerified] = useState(false)

  useEffect(() => {
    handleDisplayVerified()
  }, [])

  const handleDisplayVerified = () => {
    setTimeout(() => {
      setDisplayVerified(true)
    }, 1200)
  }

  return(
    <div className={classes.container}>
      <div className={classes.content}>
        {displayVerified ?
          <>
            <CheckCircleOutlineIcon
              fontSize='large'
              className={classes.checked}
            />
            <Typography variant='h5' gutterBottom>
              {message}
            </Typography>
            {isComplete &&
              <>
                <LinearProgress className={classes.redirecting}/>
                <Typography variant='caption'>
                  Redirecting you to the home page...
                </Typography>
              </>
            }
          </>
          :
          <CircularProgress />
        }
      </div>
    </div>
  )
}

export default ConfirmationAnimation
